module.exports = __webpack_public_path__ + "static/media/error.9fffff56.png";